import { TextProps, Text } from "@chakra-ui/react";
import {
  SyncState,
  WalletImportMethod,
  PopulatedWallet,
} from "@syla/shared/types/models/WalletBase";
import { formatDistanceStrict } from "date-fns";
import React from "react";
import { getEstimatedSyncTime } from "./helpers/getEstimatedSyncTime";

export const LastSyncedTime = ({
  lastUpdated,
  walletResponse,
  ...props
}: {
  lastUpdated: Date | undefined;
  walletResponse: DataSourceWalletResponse;
} & TextProps) => {
  const syncText =
    walletResponse.importMethod === WalletImportMethod.API ?
      "synced"
    : "imported";

  const distanceText =
    lastUpdated ?
      `${syncText} ${formatDistanceStrict(lastUpdated, new Date())} ago`
    : `never ${syncText}`;

  const estSyncTime = getEstimatedSyncTime(walletResponse.dataSource);

  const lastSyncedText =
    walletResponse.syncState === SyncState.InProgress && estSyncTime ?
      `estimated ${estSyncTime}`
    : distanceText;

  return (
    <Text color="gray.500" {...props}>
      {lastSyncedText}
    </Text>
  );
};

type DataSourceWalletResponse = Pick<
  PopulatedWallet,
  | "_id"
  | "dataSource"
  | "allowSync"
  | "lastSynced"
  | "updatedAt"
  | "importMethod"
  | "transactionCount"
  | "holdings"
  | "customName"
  | "isLocked"
  | "syncState"
>;
